import z from "zod/v4";
import { DB_USER_ID } from "../db/user-repository";

export const UserSchema = z.object({
    id: z.string(),
    username: z.string(),
    collectionId: z.string(),
    createdAt: z.number(),
    lastSync: z.number().optional(),
});

export type User = z.infer<typeof UserSchema>;

export type UserWithoutID = Omit<User, "id">;

export const User = {
    from: (user: UserWithoutID): User => ({
        ...user,
        id: DB_USER_ID,
    }),
};
